import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../shared/shared.module';
import { AllForHireRoutingModule } from './all-for-hire-routing.module';
import { AllForHireComponent } from './all-for-hire.component';
import { AllForHireResolve } from './all-for-hire.resolve';
import { ForHireModule } from './for-hire/for-hire.module';
import { AaHeroModule } from '../../shared/public-components/aa-hero/aa-hero.module';
import { SearchModule } from '../../shared/public-components/search/search.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    ForHireModule,
    MatDialogModule,
    AllForHireRoutingModule,
    AaHeroModule,
    SearchModule,
  ],
  declarations: [AllForHireComponent],
  entryComponents: [],
  exports: [AllForHireComponent],
  providers: [AllForHireResolve],
})
export class AllForHireModule {}
